import {TiberForm} from "./tiber-form.js";

/**
 * Represents a REST-based form functionality within the TiberForm framework.
 * Extends the TiberForm base class and provides additional capabilities
 * specific to integrating forms with RESTful services.
 *
 * The `TiberFormRestForm` class is designed to manage form-related features,
 * leveraging REST APIs for data submissions and retrievals.
 *
 * @class TiberFormRestForm
 * @extends TiberForm
 *
 * @param {HTMLElement} hostElement - The DOM element that serves as the container for the form.
 * @param {Object} configuration - Configuration options to customize the form behavior and appearance.
 */
export class TiberFormRestForm extends TiberForm {
    constructor(hostElement, configuration) {
        super(hostElement, configuration);
    }
}